import {
  ACCESS_LEVEL_LABEL,
  type AccessLevel,
  MODULE_LABEL,
  type ModuleKey,
} from '~/session/access';

const TAG_CLASS_BY_LEVEL: Record<AccessLevel, string> = {
  NONE: 'rx-tag',
  READ: 'rx-tag rx-tag-warn',
  FULL: 'rx-tag rx-tag-pos',
};

interface AccessLevelTagProps {
  module: ModuleKey;
  level: AccessLevel;
}

/** "NFS-e · Completo": o módulo e o nível, com a cor do nível. */
export function AccessLevelTag({ module, level }: AccessLevelTagProps): JSX.Element {
  return (
    <span className={TAG_CLASS_BY_LEVEL[level]}>
      {MODULE_LABEL[module]} · {ACCESS_LEVEL_LABEL[level]}
    </span>
  );
}
